import { IAtTagProps } from '@/components/atoms';
import {
  EClickableVariants,
  EClickableTypes,
} from '@/components/atoms/at-clickable/at-clickable.types';
import { EIcons } from '@/components/atoms/at-icon/icons';
import { ETagVariants } from '@/components/atoms/at-tag/at-tag.types';
import { getHomePlanUrl } from '@/components/helpers/formatters/home-plans';
import { MlCard } from '@/components/molecules';
import { EMlCardsTypes } from '@/components/molecules/ml-card/ml-card.types';
import { IPromo, EThemes } from '@/lib/contentstack-sdk/types';
import { TRenderCardItem } from '../or-filtered-grid.types';

const isPromoItem = (item: TRenderCardItem): item is IPromo => {
  return (item as IPromo).uid !== undefined;
};

export const renderCard = (
  item: TRenderCardItem,
  studioId?: number,
  props?: React.HTMLAttributes<HTMLElement>,
) => {
  if (isPromoItem(item)) {
    return (
      <MlCard
        tabIndex={0}
        theme={EThemes.DARK}
        chipProps={{
          label: 'Limited Time Offer',
          icon: EIcons.PRICE,
        }}
        variant={EMlCardsTypes.PROMO}
        title={item?.title || ''}
        ctaProps={{
          children: 'Claim the Offer',
          href: item?.cta?.url?.href || '',
          variant: EClickableVariants.PRIMARY,
          type: EClickableTypes.CTA,
          outline: true,
          interactLocation: 'HomePlanFilteredGrid',
        }}
        body={item.promo_description}
      />
    );
  }

  if (!item.Plan) {
    return <></>;
  }
  const url = getHomePlanUrl(item.Plan.Name);

  const planFeatures: string[] = [
    `${item?.Plan?.Bedrooms} BED`,
    `${item?.Plan?.Bathrooms} BATH`,
    `${item.SquareFeet} SQ.FT`,
    !!studioId && item.BaseElevationPrice
      ? `$ ${item?.BaseElevationPrice.toLocaleString()} +`
      : '',
  ].filter(Boolean);

  return (
    <MlCard
      key={item?.Id}
      showFavouriteButton={false}
      onFocus={props?.onFocus}
      tabIndex={0}
      href={url}
      className="cursor-pointer"
      variant={EMlCardsTypes.HOME_PLAN}
      imageProps={{
        src: {
          mobile: item.Image || '',
          tablet: item.Image || '',
          desktop: item.Image || '',
        },
        alt: item.Plan.Name,
      }}
      homePlanProps={{
        id: item.Plan.Id,
        name: item?.Plan.Name,
        description: item.ExteriorStyle.Name || '',
        features: planFeatures,
        tags: (() => {
          const tags: IAtTagProps[] = [];

          if (studioId && item.FloorPlans?.[0].HasModelHome) {
            tags.push({
              children: '+ Model Tour',
              variant: ETagVariants.FEATURED,
            });
          }

          tags.push({
            children: `${item.ExteriorStylesCount} Exteriors`,
            variant: ETagVariants.DEFAULT,
          });

          return tags;
        })(),
      }}
    />
  );
};
